import { attr, css, customElement, html, FoundationElement, when } from '@genesislcap/web-core';
import { classNames } from '@microsoft/fast-web-utilities';

@customElement({
  name: 'icon-status-badge',
  template: html<IconStatusBadge>`
    <div
      class="badge ${(x) => classNames(['lg', x.large])}"
      style="${(x) => {
        const color = x.color || 'var(--badge-color, white)';
        const background = x.backgroundColor || 'var(--badge-background, grey)';
        return `color: ${color}; background: ${background};`;
      }}"
    >
      ${when(
        (x) => x.iconName,
        html<IconStatusBadge>`
          <rapid-icon name="${(x) => x.iconName}"></rapid-icon>
        `,
      )}
      <span>${(x) => x.badgeText}</span>
    </div>
  `,
  styles: css`
    .badge {
      font-size: 12px;
      display: flex;
      align-items: center;
      gap: 5px;
      border-radius: 10px;
      height: 20px;
      background: grey;
      color: white;
      padding: 2px 8px;
      line-height: 1;
    }

    .badge.lg {
      height: 32px;
      border-radius: 16px;
      padding: 2px 12px;
    }
  `,
})
export class IconStatusBadge extends FoundationElement {
  @attr({ attribute: 'background-color' }) backgroundColor: string;

  @attr color: string;

  @attr({ attribute: 'icon-name' }) iconName: string;

  @attr({ attribute: 'badge-text' }) badgeText: string;

  @attr({ mode: 'boolean' }) large: boolean;
}
